// extracted by mini-css-extract-plugin
module.exports = {"component":"row_component__NJ98J"};